import {
  GET_USER,
  SHOW_USER,
  CREATE_USER,
  EDIT_USER,
  DELETE_USER,
  GENERAL_GET_USER
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_USER]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/users",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_USER]({ dispatch }, params) {
      let url = "/kanri/users/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_USER]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/users",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_USER]({ dispatch }, params) {
      let url = "/kanri/users/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_USER]({ dispatch }, params) {
      let url = "/kanri/users/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GENERAL_GET_USER]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/users/general_get",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
